export const INPUT_LIMITS = {
  email: 255,
  password: 128,
  companyName: 120,
  address: 180,
  city: 80,
  postCode: 20,
  payee: 120,
  sortCode: 32,
  accountNumber: 34,
  invoiceNumber: 60,
  customerName: 120,
  customerAddress: 180,
  customerCity: 80,
  customerPostCode: 20,
  phoneNumber: 32,
  notes: 2000,
  terms: 4000,
  itemDescription: 240,
  jobName: 120,
  jobDescription: 400,
  termsVersion: 40,
};

export const clampText = (value, max) => {
  if (typeof value !== "string") return "";
  if (!Number.isFinite(max) || max <= 0) return value;
  return value.slice(0, max);
};

export const clampFields = (payload, limits) => {
  const next = { ...payload };
  Object.entries(limits).forEach(([key, max]) => {
    if (typeof next[key] === "string") {
      next[key] = clampText(next[key], max);
    }
  });
  return next;
};
